import { configureStorage } from '@qcdoc/mock-runtime/database.ts';
import { PORTAL } from '../app/portal.ts';

configureStorage({
  getItem: (key) => localStorage.getItem(PORTAL === 'combined' ? key : `qcdoc.${PORTAL}.${key}`),
  setItem: (key, value) => localStorage.setItem(PORTAL === 'combined' ? key : `qcdoc.${PORTAL}.${key}`, value),
  removeItem: (key) => localStorage.removeItem(PORTAL === 'combined' ? key : `qcdoc.${PORTAL}.${key}`),
});